const target = '.anchor-link > a';
const offset = 100;
const duration = 100;
jQuery(document).on('ready', function () {
    jQuery('a').click(function () {
        let href = jQuery(this).attr('href');
        jQuery([document.documentElement, document.body]).animate({
            scrollTop: jQuery(href).offset().top - offset
        }, duration);
    });
});
